import { axiosInstance as axios } from '../../axios/axios';
import * as Action from '../actions/index';
import { getErrorMsg } from '../../utils/customizeError';

export const createReservation = (data, setLoading, token) => {
  return async (dispatch) => {
    try {
      setLoading(true);
      await axios.post('api/reservations', data, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      setLoading(false);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg: 'Reservation Successful', type: 'success' },
      });
    } catch (err) {
      const msg = getErrorMsg(err);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg, type: 'error' },
      });
      setLoading(false);
    }
  };
};
export const deleteReservation = (id, setLoading, token) => {
  return async (dispatch) => {
    try {
      await axios.delete(`/api/reservations/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      dispatch({ type: Action.DELETE_RESERVATION, payload: id });
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg: 'Deletion Successful', type: 'success' },
      });
    } catch (err) {
      const msg = getErrorMsg(err);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg, type: 'error' },
      });
      setLoading(false);
    }
  };
};
